// extracted by mini-css-extract-plugin
export default {"container":"user-chat-message_container__7L42-","message":"user-chat-message_message__Hjqou"};